var map = {
	"./en": [
		2497,
		497
	],
	"./en.js": [
		2497,
		497
	],
	"./ja": [
		5407,
		407
	],
	"./ja.js": [
		5407,
		407
	],
	"./zh": [
		5152
	],
	"./zh.js": [
		5152
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3079;
module.exports = webpackAsyncContext;